module.exports = __webpack_public_path__ + "media/images/front/noimage_180x180-d4e529c757073d45a3a5d92c9d3f7a21.png";